import { render, staticRenderFns } from "./SettingsFields.vue?vue&type=template&id=235610b4&"
import script from "./SettingsFields.vue?vue&type=script&lang=ts&"
export * from "./SettingsFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports